export default __webpack_public_path__ + "static/media/background-6-mobile.49975870.png";